"use client";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

const SelectComponent = ({
  label,
  value,
  error,
  errorMessage,
  menuItems = [],
  singleItemArray = [],
  required = false,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // useEffect(() => {
  //   const onPopState = () => {
  //     // close the menu when navigation occurs (back/forward/swipe-back)
  //     setOpen(false);
  //   };

  //   window.addEventListener("popstate", onPopState);
  //   return () => window.removeEventListener("popstate", onPopState);
  // }, []);

  useEffect(() => {
    const onPopState = () => {
      if (open) {
        setOpen(false);
        window.history.pushState(null, document.title, window.location.href);
      }
    };

    if (open) {
      window.history.pushState(null, document.title, window.location.href);
    }

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [open]);

  const theme = useTheme();
  const t = useTranslations("Validations");
  return (
    <FormControl fullWidth required={required}>
      <InputLabel id="demo-simple-select-label" error={error}>
        {label}
      </InputLabel>
      <Select
        open={open}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        onOpen={handleOpen}
        onClose={handleClose}
        label={label}
        error={error}
        sx={{
          textTransform: "capitalize",
          backgroundColor: "#fff",
          "& .MuiInputBase-root": {
            backgroundColor: "#fff",
          },
          "& .MuiOutlinedInput-input": {
            backgroundColor: "#fff",
          },
        }}
        {...props}>
        {Array.isArray(menuItems) &&
          menuItems?.map((item) => (
            <MenuItem
              sx={{
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: theme.palette.primary.main,
                  color:
                    item?.value === value
                      ? theme.palette.primary.main
                      : theme.palette.pale.main,
                },
              }}
              key={item?.id}
              value={item?.value}>
              {" "}
              {item?.name?.toLowerCase()}
            </MenuItem>
          ))}
        {Array.isArray(singleItemArray) &&
          singleItemArray?.map((item, i) => (
            <MenuItem
              sx={{
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: theme.palette.primary.main,
                  color:
                    item === value
                      ? theme.palette.primary.main
                      : theme.palette.pale.main,
                },
              }}
              key={i}
              value={item}>
              {" "}
              {item}
            </MenuItem>
          ))}
      </Select>
      {error && (
        <FormHelperText sx={{ color: "#d32f2f" }}>
          {t(errorMessage)}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectComponent;
